import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const VideoCanvas = ({ src }) => {
    const videoRef = useRef(null);
    let hls
    useEffect(() => {
        const video = videoRef.current;
        if (Hls.isSupported()) {
            hls = new Hls();
            hls.loadSource(src);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, function () {
                video.play();
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = src;
            video.addEventListener('canplay', function () {
                video.play();
            });
        }

        return () => {
            if (Hls.isSupported()) {
                hls.destroy();
            }
        };
    }, [src]);

    return (
        <video
            ref={videoRef}
            style={{ width: '100%' }}

        />
    );
};

export default VideoCanvas;
